import { useAppDispatch, useAppSelector } from 'app/hooks';
import Spinner from 'components/Spinner/Spinner';
import { DateTime } from 'luxon';
import { useEffect } from 'react';
import { getUserPackages } from 'services/auth/packages.service';
import { colors } from 'styles';
import { H3, P2 } from '../../styles/FontStyles';
import { Div } from '../../styles/Styles';
import { StatusPill, TableHead, TableRow } from './Orders.styled';
import { useNavigate } from 'react-router-dom';
import { renderPillColor, renderTextColor } from 'helpers/helpers';

export const Orders = () => {
  const navigate = useNavigate();
  const { loading, userPackages } = useAppSelector((state) => state.packages);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getUserPackages());
  }, [dispatch]);

  return (
    <>
      {loading && <Spinner fullscreen={true} transparent />}

      <Div $width='65%' $widthSM='100%'>
        <H3 color={colors.white} mb='20'>
          Order Status
        </H3>

        <Div $desktop>
          <TableHead $flex $alignCenter>
            <Div $width='15%'>
              <P2>Order Id</P2>
            </Div>
            <Div $width='20%'>
              <P2>Created</P2>
            </Div>
            <Div $width='25%'>
              <P2>Item</P2>
            </Div>
            <Div $width='20%'>
              <P2>Total</P2>
            </Div>
            <Div $width='20%'>
              <P2>Status</P2>
            </Div>
          </TableHead>
        </Div>

        <Div $desktop>
          {userPackages.map((userPackage: any, index: number) => (
            <TableRow
              $box
              $flex
              $alignCenter
              key={index}
              onClick={() =>
                navigate(`/dashboard/payment-summary/${userPackage?.id}`)
              }
            >
              <Div $width='15%'>
                <P2 bold>{userPackage.id}</P2>
              </Div>
              <Div $width='20%'>
                <P2 bold>
                  {DateTime.fromISO(userPackage?.dateCreated ?? '').toFormat(
                    'dd MMM yyyy'
                  )}
                </P2>
              </Div>
              <Div $width='25%'>
                <P2 bold>{userPackage.packageName}</P2>
              </Div>
              <Div $width='20%'>
                <P2 bold>{userPackage.price} USDC</P2>
              </Div>
              <Div $width='20%'>
                <StatusPill
                  $color={renderPillColor(userPackage.status)}
                  $textColor={renderTextColor(userPackage.status)}
                >
                  {userPackage.status}
                </StatusPill>
              </Div>
            </TableRow>
          ))}
        </Div>

        <Div $mobile>
          {userPackages.map((userPackage: any, index: number) => (
            <TableRow
              $box
              $flex
              key={index}
              onClick={() =>
                navigate(`/dashboard/payment-summary/${userPackage?.id}`)
              }
            >
              <Div $width='35%'>
                <P2>Order Id</P2>
                <P2 bold mb='20'>
                  {userPackage.id}
                </P2>

                <P2>Created</P2>
                <P2 bold>
                  {DateTime.fromISO(userPackage?.dateCreated ?? '').toFormat(
                    'dd MMM yyyy'
                  )}
                </P2>
              </Div>
              <Div $width='35%'>
                <P2>Item</P2>
                <P2 bold mb='20'>
                  {userPackage.packageName}
                </P2>

                <P2>Total</P2>

                <P2 bold>{userPackage.price} USDC</P2>
              </Div>
              <Div $width='30%' $flex $justifyEnd>
                <StatusPill
                  $color={renderPillColor(userPackage.status)}
                  $textColor={renderTextColor(userPackage.status)}
                >
                  {userPackage.status}
                </StatusPill>
              </Div>
            </TableRow>
          ))}
        </Div>
      </Div>
    </>
  );
};
